<h2 mat-dialog-title>Install Angular</h2>
<mat-dialog-content class="mat-typography">
    <ng-container [ngTemplateOutlet]="config?.templateOutlet"></ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button [mat-dialog-close]="true" >Install</button>
</mat-dialog-actions>
